angular.module('kareo.ui.shared.modules.data-filters', [])
.filter 'telephone', ->
  (phoneNumber) ->
    return '' if not phoneNumber

    number = ''
    if phoneNumber.length >= 10
      number =
        '(' + phoneNumber[0 .. 2] + ') ' +
          phoneNumber[3 .. 5] + '-' +
          phoneNumber[6 .. 9]

      if phoneNumber.length > 10
        phoneNumber += ' ' + phoneNumber[10 .. phoneNumber.length]
    else if phoneNumber.length is 7
      number =
        phoneNumber[0 .. 2] + '-' + phoneNumber[3 .. 6]

    return number
.filter 'dob', ->
  (dobMilliSeconds) ->
    dob = new Date(dobMilliSeconds)
    moment(dob).utc().format('MM/DD/YYYY')
.filter 'age', ->
  (dob, now) ->
    if ( typeof dob == 'string' )
      dob = new Date(dob)
    dob = moment(dob).utc()
    formattedDate = dob.format('MM/DD/YYYY')
    now ?= new Date

    abs_month = (date) ->
      date.getFullYear() * 12 + date.getMonth() + date.getDate() * .01

    months = Math.floor abs_month(now) - abs_month(dob.toDate())
    years = Math.floor months / 12
    # months = months % 12

    return formattedDate + ' (' + years + ' y/o)'
.filter 'zipcode', ->
  (zip) ->
    return '' if !zip
    str = zip.toString()
    if str.length == 9
      return str.substr(0, 5) + '-' + str.substr(5)
    str
